import { z } from "zod";

/**
 * FILL activity rows from Gobroker activities. Optional fill-specific fields
 * stay `.nullish()` so a missing key does not drop the row via `looseArray`.
 */
export const orderFillSchema = z.object({
  id: z.string(),
  activity_type: z.string(),
  transaction_time: z.string().nullish(),
  type: z.string().nullish(),
  price: z.string().nullish(),
  qty: z.string().nullish(),
  side: z.string().nullish(),
  symbol: z.string().nullish(),
  leaves_qty: z.string().nullish(),
  cum_qty: z.string().nullish(),
  order_id: z.string().nullish(),
  order_status: z.string().nullish(),
  commission: z.string().nullish(),
  net_amount: z.string().nullish(),
});

export type OrderFill = z.infer<typeof orderFillSchema>;
